import React from 'react';
import localization from 'assets/localization/localization';
import './cardSection.css';
import ReactTooltip from "react-tooltip";

const CardSection = ({ children, title, status, remove, removeIt, display = false, size, invoice_creation,servClass=null }) => {
  
  function changeDisplay() {
    display = !display;
    if (size !== undefined) {
      for (let i = 0; i < size; i++) {
        if (display) {

          document.getElementsByClassName("display-description")[i].style.display = "block";
        }
        else {
          document.getElementsByClassName("display-description")[i].style.display = "none";

        }
      }
    }
  }

  return (
   <div className="panel-first">
    <div className="panel-list panel-list-align">
       
    <div className="panel-card ">
    
      <div className="panel-heading">

        <div>
        {title}
          &nbsp;
          { (invoice_creation == 1) &&
            <>
            
              <svg style={{ cursor: 'pointer' }} width="30" height="20" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" data-tip data-for="registerTip{data.stage_id}">
                <circle cx="6.5" cy="6.5" r="5.5" stroke="#FF0000" />
                <path d="M6.50137 4.09C6.3347 4.09 6.1947 4.03333 6.08137 3.92C5.96803 3.80667 5.91137 3.67 5.91137 3.51C5.91137 3.35 5.96803 3.21333 6.08137 3.1C6.1947 2.98 6.3347 2.92 6.50137 2.92C6.66137 2.92 6.79803 2.98 6.91137 3.1C7.0247 3.21333 7.08137 3.35 7.08137 3.51C7.08137 3.67 7.0247 3.80667 6.91137 3.92C6.79803 4.03333 6.66137 4.09 6.50137 4.09ZM6.93137 10H6.06137V5H6.93137V10Z" fill="#FF0000" />
              </svg>
            
            <ReactTooltip id="registerTip{data.stage_id}" place="left" type="info">
              Invoice will be generated at this stage completion!
            </ReactTooltip>
            </>
          }
        </div>
        {status && (
           <div className="panel_Design">
          <span
            className={`status-td ${status === 'In Progress'
                ? `warm`
                : status === 'Not Started'
                  ? 'cold'
                  : status === 'Completed'
                    ? 'completed'
                    : ''
              }`}
          >
            {status}
          </span>
          </div>
         
        )}
        {remove && (
          <a
            className="field-remove"
            onClick={() => {
              removeIt(true);
            }}
          >
            {localization.remove}
          </a>
        )}
         </div>
    
      
      <div className={`panel_grid ${servClass}`}>{children}</div>
    </div>
   
     </div>
     </div>
  );
};

export default CardSection;
